import { AlertService } from './../../service/alert.service';
import { FormControl, FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ProdutosService } from './../../service/produtos.service';
import { Produtos } from './../../model/produtos.model';
import { PermissoesService } from './../../service/permissoes.service';
import { Permissoes } from './../../model/permissao.model';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criar-permissao',
  templateUrl: './criar-permissao.component.html',
  styleUrls: ['./criar-permissao.component.css']
})
export class CriarPermissaoComponent implements OnInit {

  form!: FormGroup;
  produtos!: Produtos[];
  permissoes!: Permissoes[];
  permissao: Permissoes = {
    vc_nome: '',
    vc_descricao: '',
  }

  constructor(private router: Router, 
    private formBuilder: FormBuilder,
    private service: PermissoesService,
    private serviceProdutos: ProdutosService,
    private alertService: AlertService,
  ) {
    this.form = this.formBuilder.group({
      vc_nome: new FormControl(''),
      vc_descricao: new FormControl(''),
      fk_produto: new FormControl('')
    })
  }

  ngOnInit(): void {
    this.listarProduto();
  }

  cadastrar(): void {
    this.service.cadastrarService(this.form.value).subscribe(resp => {
      this.alertService.success();
      this.router.navigate(['configuracao/permissoes']);
    }, error => {
      this.alertService.error(error);
    })
  }

  listarProduto():void {
    this.serviceProdutos.listarService().subscribe(resp => {
      this.produtos = resp
    })
  }

  cancel(){
    this.router.navigate(['configuracao/permissoes']);
  }

}
